import _ from 'underscore';

import { getCanonicalUrl } from '../url';

export const getBreadcrumbsMicrodata = (breadcrumbs) => {
	const itemListElement = _(breadcrumbs).map((breadcrumb, index) => ({
		'@type': 'ListItem',
		position: index + 1,
		item: {
			'@id': getCanonicalUrl({ rubric: breadcrumb }),
			name: breadcrumb.title
		}
	}));

	const jsonData = {
		'@context': 'http://schema.org',
		'@type': 'BreadcrumbList',
		itemListElement
	};

	return JSON.stringify(jsonData);
};
